import { ref } from 'vue'
import { defineStore } from 'pinia'
import type { Toast, ToastType } from '@/types/toast'

export const useToastStore = defineStore('toast', () => {
  const toasts = ref<Toast[]>([])
  // A counter rather than Date.now(): two toasts created in the same
  // millisecond would share an id and expire together
  let nextToastId = 0

  function addToast(type: ToastType, message: string, duration = 3000) {
    const id = ++nextToastId
    const newToast: Toast = { id, type, message, duration, visible: true }
    toasts.value.push(newToast)

    setTimeout(() => {
      removeToast(id)
    }, duration)
  }

  function removeToast(id: number) {
    const index = toasts.value.findIndex((toast) => toast.id === id)
    if (index > -1) {
      toasts.value[index].visible = false

      setTimeout(() => {
        toasts.value = toasts.value.filter((toast) => toast.id !== id)
      }, 500)
    }
  }

  function clearAllToasts() {
    toasts.value = []
  }

  return {
    toasts,
    addToast,
    removeToast,
    clearAllToasts,
  }
})
